import { createSlice } from '@reduxjs/toolkit';

import type { AjusteNegociacaoGrupo } from '../types/verificacao.types';
import { listarAjustesNegociacao } from './actions';

interface AjustesNegociacaoState {
  ajustesGrupos: AjusteNegociacaoGrupo[];
  ajustesEscopo: string | null;
  isLoadingAjustes: boolean;
  ajustesError: string | null;
  currentRequestId: string | null;
}

const initialState: AjustesNegociacaoState = {
  ajustesGrupos: [],
  ajustesEscopo: null,
  isLoadingAjustes: false,
  ajustesError: null,
  currentRequestId: null,
};

const ajustesNegociacaoSlice = createSlice({
  name: 'negociacoes/ajustes',
  initialState,
  reducers: {
    clearAjustesNegociacao: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarAjustesNegociacao.pending, (state, action) => {
        state.isLoadingAjustes = true;
        state.ajustesError = null;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(listarAjustesNegociacao.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.isLoadingAjustes = false;
        state.ajustesGrupos = action.payload;
        state.ajustesEscopo = action.meta.arg ?? null;
        state.currentRequestId = null;
      })
      .addCase(listarAjustesNegociacao.rejected, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.isLoadingAjustes = false;
        state.ajustesError = action.payload ?? 'Erro ao carregar as pendências de ajuste';
        state.currentRequestId = null;
      });
  },
});

export const { clearAjustesNegociacao } = ajustesNegociacaoSlice.actions;
export default ajustesNegociacaoSlice.reducer;
